import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators, UntypedFormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { CountService } from 'src/app/core/services/count.service';
import { OrdersService } from 'src/app/core/services/orders.service';
import { SharedService } from 'src/app/core/services/shared.service';

@Component({
  selector: 'app-demo-submissions',
  templateUrl: './demo-submissions.component.html',
  styleUrls: ['./demo-submissions.component.scss']
})
export class DemoSubmissionsComponent {

  
   pageSizeOptions: number[] = [10, 20, 50, 100]; 
   private modalRef: NgbModalRef | null = null;
    headerData: any;
    ogData:any;
    customers: any;
    fullData: any;
    apiData: any = []; 
    pageIndex:number = 0;
    pageSize:number=4;
    page:any; 
    searchdata:any;   
    searchdata1 = true;
    searchdata2 = true; 
    showOverlay =false  
    length=0
    fullData22 :any
    page_no:number=1; 
    config:any;
    headerid:any;
    length1:any;
    username:any; 
    paginate: any = {
      length: 0,
      pageIndex: 0,
      pageSize: 10,
      previousPageIndex: 1
      }
      value:any;
      searchchar:boolean = false
      selectedSearchType: 'orders' | 'products' = 'orders'; 
      searchTerm: string = '';
    pageEvent:any;
    startIndex:any
    displayedColumns: string[] | undefined;
    @ViewChild(MatPaginator, { static: true }) paginator:
      | MatPaginator
      | undefined;
    @ViewChild(MatSort, { static: false }) sort: MatSort | undefined;
 
  vendorForm = new FormControl('');
  private modalService = inject(NgbModal);
    fulllength: any;
    @ViewChild('select') select: MatSelect;
    orderid = new FormControl("", [Validators.required]);

  
    constructor(
      private _order:OrdersService,
      private authService:AuthenticationService,
      private toastr: ToastrService,
      private router: Router,
      private formBuilder: UntypedFormBuilder,
      private countservice : CountService,
          private _shared:SharedService
      
      ){
  
    }
    ngOnInit(): void { 
      this.initform('');
      this.fetchData(this.paginate); 
    } 
    onSubmit() {
      if (this.updateform.valid) {
        this.showOverlay=true;
        console.log("Form Values:", this.updateform.value); 
        let data = this.updateform.value
        this.authService.update_demo(data).subscribe((res:any)=>{
          let mes =JSON.parse(res);
          res =mes
          if(res.statusCode >=200 && res.statusCode <=205){
            this.showOverlay =false;
            this.modalService.dismissAll();
            this.updateform.reset(); 
            this.fetchData(this.paginate)
          }
          else{
            this.showOverlay =false;
            this.modalService.dismissAll();
          }
        })
      }
    }




    search_submit(){
      this.fetchData(this.paginate);
    }

  search_data =new FormControl('');
  fetchData(event:any) { 
    this.showOverlay = true 
    // this.showOverlay=true 
    this.paginate = event;
    this.length = +event.length;
    this.pageIndex = +event.pageIndex;
    this.pageSize = +event.pageSize;
    this.startIndex = +event.pageIndex * event.pageSize
    let page_no = this.pageIndex > 0 ? this.pageIndex + 1 : 1 
   
    let data = this.search_data.value
//  console.log(data)s
// get_raised_demo_subbmisions
 this.authService.get_raised_demo_subbmisions(data).subscribe((res: any) => {
  console.log(res);
  let mes = JSON.parse(res);
  res = mes 
  // console.log(mes);
  res = mes
   if (mes.statusCode >= 200 && mes.statusCode <=205) {
    console.log("cs",mes)
    if(mes.statusCode !=204){
     this.showOverlay = false; 
      this.length=mes.pagination.total_record_count
      this.fullData = mes.Data;
      this.ogData =mes.Data;
     this.headerData = mes.header;
     this.getData(this.fullData); 
    this.fulllength = mes.pagination.total_record_count

    }
    else{
      this.showOverlay =false
    }

   }  
   else{
    if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
      // this.authService.logout()
      this.showOverlay=false
      this.router.navigate(['/auth/login'])
    }
    else{
      this.toastr.error(res.error, "");
      this.showOverlay = false;
      this.fullData = []; 
    //  this.headerData = mes.column_headers;
     this.getData(this.fullData);  
    }
    // this.showOverlay= false

   }
  
 }, 
 (error) => {
  this.showOverlay = false;
  if (error.status === 502) {
    this.toastr.error("502 Bad Gateway", "An error occurred");
  } else {
    this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
  }
});
}

getData(data:any) { 
  this.apiData = data; 
  console.log("Table Data:", this.apiData);  // ✅ check values here
  this.headerData.actions = "Action";  
  this.displayedColumns = Object.keys(this.headerData);
  this.customers = new MatTableDataSource(this.apiData);
  this.customers.sort = this.sort; 
} 

updateform:FormGroup;
customer_id =new FormControl('')
first_name =new FormControl('')
last_name =new FormControl('')
email =new FormControl('')
phone =new FormControl('')
message =new FormControl('')
is_responded =new FormControl('')
respond_method =new FormControl('')

initform(data?: any) {
  this.updateform = new FormGroup({
    customer_id: new FormControl(data?.customer_id || ''),
    first_name: new FormControl(data?.first_name || ''),
    last_name: new FormControl(data?.last_name || ''),
    email: new FormControl(data?.email_id || ''),
    phone: new FormControl(data?.phone || ''),
    message: new FormControl(data?.message || ''),
    is_responded: new FormControl(data?.is_responded || false),
    respond_method: new FormControl(data?.respond_method || ''),
    ticket_status: new FormControl(data?.ticket_status || '')
  });
}

close_dialog(){
  this.updateform.reset();
  this.modalService.dismissAll();
}

openupdateform(data:TemplateRef<any>,row:any){
  console.log('dcsscd',row)
  this.initform(row);
  this.modalService.open(data,{ centered: true,size: 'md'})
}


apiresponse:any
alt_order_id:any
apiresponse11:any 

update_clone_orders(){
  this.showOverlay = true
  let data  = { 
    'status':'pending', 
  }
  data['product_data'] = {};
  this.apiresponse.forEach(item => {
    if (item.buymore_sku) {
      data['product_data'][item.buymore_sku] = item.qty;
    }
  });  
  console.log(data,'data')
  this.authService.create_clone_orders(data).subscribe((res: any) => {
    let mes = JSON.parse(res);
    res = mes
     if (mes.statusCode === 200) {
       this.showOverlay = false;
       this.apiresponse = mes.response
       this.modalService.dismissAll() 
     } 
     else{
      if(mes.error =='Token has expired' || mes.error =='Invalid token' || mes.error =='Token is required'){
        this.showOverlay=false
        this.router.navigate(['/auth/login'])
      }
      else{
        this.toastr.error(mes.error, "");
        this.showOverlay = false; 
      }
    
     }
    
    }, 
    (error) => {
    this.showOverlay = false;
    if (error.status === 502) {
      this.toastr.error("502 Bad Gateway", "An error occurred");
    } else {
      this.toastr.error("An error occurred while communicating with the server.", "Please Try Again After some time");
    }
    });

} 
}
